import { useTranslation } from "react-i18next"
import { useShowProps } from "./page-props"
import { PageChrome } from "@/components/page-chrome"
import { Home } from "lucide-react"
import { PageBody } from "@/components/ui/layout"
import { Card, CardContent } from "@/components/ui/card"
import { WorkspaceLinkCards } from "@/components/workspace/link-cards"
import { WORKSPACE_OWNERS } from "@/components/workspace/definition"
import { useRouteWorkspace } from "@/components/workspace/page-chrome"

export default function Page() {
  const { school } = useShowProps()
  const workspace = useRouteWorkspace(WORKSPACE_OWNERS.school)
  const { t } = useTranslation("nav")

  return (
    <>
      <PageChrome
        icon={Home}
        title={t("school_admin_workspace_title", {
          name: school.school_name || "",
        })}
      />
      <PageBody role="region">
        <Card>
          <CardContent
            className="grid grid-cols-2 gap-6 py-6"
            aria-label="Actions"
            role="navigation"
          >
            <WorkspaceLinkCards workspace={workspace} />
          </CardContent>
        </Card>
      </PageBody>
    </>
  )
}
